import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import bem from 'utils/bem';
import { useMobile } from 'utils/media';
import { Dialog } from '@mui/material';
import KZLoginForm from '../index';
import KZRegisterForm from 'forms/forms/KZRegisterForm';
import Model from '../../../../../model';
import Icon from 'components/Icon';

import './index.sass';

const { block, el } = bem('kz-login-form-modal');

const KZLoginFormModal = ({ initial = 'login' }) => {

    const [ currentForm, setCurrentForm ] = useState(initial);
    const { closeKZLoginForm, isKZLoginFormOpen, kzLoginCallback } = Model.modal;
    const { isMobile } = useMobile();

    const switchToLogin = () => {
        setCurrentForm('login');
    }
    const switchToRegister = () => {
        setCurrentForm('register');
    }
    const resetCurrentForm = () => {
        setCurrentForm(initial);
    }

    const rForm = () => {
        switch (currentForm) {
            case 'login':
                return <KZLoginForm switchToRegister={switchToRegister} closeModal={handleClose} callback={kzLoginCallback}/>
            case 'register':
                return <KZRegisterForm switchToLogin={switchToLogin} resetCurrentForm={resetCurrentForm} callback={kzLoginCallback}/>
            default:
                return null
        }
    };

    const handleClose = () => {
        closeKZLoginForm();
    }

    return (
        <>
            <Dialog
                className={ block() }
                open={ isKZLoginFormOpen }
                onClose={ handleClose }
                fullWidth={ true }
                fullScreen={ isMobile }
                maxWidth={ 'md' }
                scroll={ 'body' }
                PaperProps={ {
                    sx: {
                        maxWidth: 600,
                        margin: '0 auto',
                        width: 600,
                        borderRadius: isMobile ? 0 : '20px'
                    }
                } }
            >
                <div className={ el('content') }>
                    <div className={ el('form') }>
                        <div className={el('header')}>
                            <div className={el('close')} onClick={handleClose}><Icon name={'x'}/></div>
                        </div>
                        { rForm() }
                    </div>
                </div>
            </Dialog>
        </>
    )
}

export default observer(KZLoginFormModal);
